import React, { useState } from "react";
import { FiFilter } from "react-icons/fi";

function Filtersidebar({
  filterData,
  filters,
  onFilterChange,
  onCheckboxChange,
  priceRange,
  onPriceChange,
  onApply,
}) {
  const [showAllCategories, setShowAllCategories] = useState(false);
  const [showAllBrands, setShowAllBrands] = useState(false);

  

  return (
    <>
      <div className="custom-filter-box p-3 rounded">
        <div className="d-flex align-items-center justify-content-between">
          <h5 className="mb-3 filter-title">
          <FiFilter className="mt-0" size={20} /> Filters
        </h5>
        <button className="btn btn-dark rounded-0 px-4"   onClick={onApply}>Apply</button>
        </div>

        {/* CATEGORY */}
        <div className="mb-3">
          <label className="custom-filter-label">Category</label>
          {(showAllCategories
            ? filterData?.categories
            : filterData?.categories?.slice(0, 7)
          )?.map((cat) => (
            <div className="custom-radio" key={cat._id}>
              <input
                type="checkbox"
                name="category"
                id={`cat-${cat._id}`}
                value={cat._id}
                checked={filters.category.includes(cat._id)}
                onChange={() => onCheckboxChange("category", cat._id)}
              />
              <label htmlFor={`cat-${cat._id}`}>{cat.name}</label>
            </div>
          ))}
          {filterData?.categories?.length > 7 && (
            <p
              className="custom-view-more"
              onClick={() => setShowAllCategories((prev) => !prev)}
            >
              {showAllCategories ? "View Less" : "View More"}
            </p>
          )}
        </div>

        {/* BRAND */}
        <div className="mb-3">
          <label className="custom-filter-label">Brand</label>
          {(showAllBrands
            ? filterData?.brands
            : filterData?.brands?.slice(0, 7)
          )?.map((b) => (
            <div className="custom-radio" key={b.id}>
              <input
                type="checkbox"
                name="brand"
                id={`brand-${b.id}`}
                value={b.id}
                checked={filters.brand.includes(b.id)}
                onChange={() => onCheckboxChange("brand", b.id)}
              />
              <label htmlFor={`brand-${b.id}`}>{b.name}</label>
            </div>
          ))}
          {filterData?.brands?.length > 7 && (
            <p
              className="custom-view-more"
              onClick={() => setShowAllBrands((prev) => !prev)}
            >
              {showAllBrands ? "View Less" : "View More"}
            </p>
          )}
        </div>

        {/* PRICE */}
        <div className="mb-4" style={{ padding: "0 10px" }}>
          <label className="custom-filter-label" style={{ fontWeight: "bold" }}>
            PRICE
          </label>
          <div className="range-slider">
            <input
              type="range"
              className="range-input"
              min={filterData?.priceRange?.min || 0}
              max={filterData?.priceRange?.max || 10000}
              value={priceRange[0]}
              onChange={(e) => {
                const val = Math.min(+e.target.value, priceRange[1] - 100);
                onPriceChange([val, priceRange[1]]);
              }}
            />
            <input
              type="range"
              className="range-input"
              min={filterData?.priceRange?.min || 0}
              max={filterData?.priceRange?.max || 10000}
              value={priceRange[1]}
              onChange={(e) => {
                const val = Math.max(+e.target.value, priceRange[0] + 100);
                onPriceChange([priceRange[0], val]);
              }}
            />
            <div
              className="slider-track"
              style={{
                left: `${
                  ((priceRange[0] - (filterData?.priceRange?.min || 0)) /
                    ((filterData?.priceRange?.max || 10000) -
                      (filterData?.priceRange?.min || 0))) *
                  100
                }%`,
                right: `${
                  100 -
                  ((priceRange[1] - (filterData?.priceRange?.min || 0)) /
                    ((filterData?.priceRange?.max || 10000) -
                      (filterData?.priceRange?.min || 0))) *
                    100
                }%`,
              }}
            />
          </div>
          <div className="price-values">
            <span>₹{priceRange[0]}</span>
            <span>₹{priceRange[1]}+</span>
          </div>
        </div>

        {/* SORT */}
        <div className="mb-3">
          <label className="custom-filter-label">Sort</label>
          {filterData?.sorting?.map((opt, i) => (
            <div className="custom-radio" key={i}>
              <input
                type="checkbox"
                name="sort"
                id={`sort-${i}`}
                value={opt.value}
                checked={filters.sort === opt.value}
                onChange={(e) => onFilterChange("sort", e.target.value)}
              />
              <label htmlFor={`sort-${i}`}>{opt.label}</label>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default Filtersidebar;
